import State from '../core/State';
import { ChartType } from '../entity/types';

const getSelectedLiftReportChart = (chartType: ChartType, state: State) => {
  if (!state.liftReports.data) {
    return;
  }

  const selectedLiftReport = state.liftReports.data.find((liftReport) => {
    return liftReport.goal.id === state.selectedGoalId.data;
  });

  if (
    !state.liftReportChartSetting.period.from.toISO() ||
    !state.liftReportChartSetting.period.to.toISO() ||
    !selectedLiftReport ||
    !selectedLiftReport.charts
  ) {
    return;
  }

  const selectedChart = selectedLiftReport.charts.find((chart) => {
    return chart.type === chartType;
  });

  return selectedChart;
};

export default getSelectedLiftReportChart;
